// extracted by mini-css-extract-plugin
module.exports = {"MobileControls":"OXmID","MobileControls__Block":"IETnd","MobileControls__ModalContent":"Bvgxs","MobileControls__ListSwitch":"HwgS8"};